import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const ThemeToggle = () => {
  const { t } = useTranslation();
  const [isDark, setIsDark] = useState(false);

  // בעת טעינת הקומפוננטה, בדוק את localStorage ועדכן את מצב הנושא
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme === "dark") {
      setIsDark(true);
      document.documentElement.classList.add("dark");
    } else {
      setIsDark(false);
      document.documentElement.classList.remove("dark");
    }
  }, []);

  const toggleTheme = () => {
    if (isDark) {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
      setIsDark(false);
    } else {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
      setIsDark(true);
    }
  };

  return (
    <button
      type="button"
      onClick={toggleTheme}
      role="switch"
      aria-checked={isDark}
      aria-label={t('theme_toggle_label')}
      className="cursor-pointer flex items-center bg-transparent border-0 p-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-300 rounded-full"
    >
      {/* סליידר עם גודל מוקטן */}
      <div
        className={`w-12 h-6 rounded-full relative transition-colors duration-300 ${
          isDark ? 'bg-gray-800' : 'bg-white'
        }`}
      >
        {/* הכפתור עם האייקון */}
        <div
          className={`absolute top-1 left-1 w-4 h-4 flex items-center justify-center transition-transform duration-300 ${
            isDark ? 'translate-x-6' : ''
          }`}
        >
          {isDark ? (
            // במצב חושך, הראה אייקון ירח (מעיד לעבור למצב אור)
            <img src="/icons/Moon.png" alt={t('theme_dark_alt')} className="w-4 h-4" />
          ) : (
            // במצב אור, הראה אייקון שמש (מעיד לעבור למצב חושך)
            <img src="/icons/Sun.png" alt={t('theme_light_alt')} className="w-4 h-4" />
          )}
        </div>
      </div>
    </button>
  );
};

export default ThemeToggle;
